import { render, staticRenderFns } from "./ContactInfoExtraInfo.vue?vue&type=template&id=9b0febe8"
import script from "./ContactInfoExtraInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfoExtraInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0febe8')) {
      api.createRecord('9b0febe8', component.options)
    } else {
      api.reload('9b0febe8', component.options)
    }
    module.hot.accept("./ContactInfoExtraInfo.vue?vue&type=template&id=9b0febe8", function () {
      api.rerender('9b0febe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoExtraInfo.vue"
export default component.exports